export default "__VITE_ASSET__iLFPcywt__"